import React, { useEffect, useState } from "react";
import { collection, getCountFromServer } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export default function TotalUsersCard() {
  const [totalUsers, setTotalUsers] = useState(null);

  useEffect(() => {
    async function loadTotal() {
      try {
        const coll = collection(db, "users");
        const snapshot = await getCountFromServer(coll);
        setTotalUsers(snapshot.data().count);
      } catch (err) {
        console.error("Erro ao buscar total de usuários:", err);
      }
    }

    loadTotal();
  }, []);

  return (
    <div className="metric-card">
      <p className="metric-label">Usuários cadastrados</p>
      <p className="metric-value">
        {totalUsers != null ? totalUsers.toLocaleString("pt-BR") : "--"}
      </p>
      <span className="metric-tag">Total geral</span>
    </div>
  );
}
